import { Checkbox, Col, ConfigProvider, Layout, Row, notification, DatePicker, Flex, Button, Input, Table, Modal, Drawer, Tabs, Skeleton } from "antd";
import { getInvoice, getInvoiceActions, getInvoiceFilters, getInvoices, saveInvoice as save } from "../../service/httpsCalls";
import { useEffect, useState, useRef } from "react";
import { Select, Divider } from 'antd';
import { PlusOutlined, SearchOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs, { Dayjs, extend } from "dayjs";
import { SorterResult } from "antd/es/table/interface";
import type { MenuProps, TableColumnsType, TableProps } from 'antd';
import { LoaderSpinner } from "../../components/common/Loader";
import { ColumnDropdown } from "../../components/common/ColumnDropdown";
import CreateInvoice, { ChildRef } from "./createInvoice";
import MakeCorrection, { ChildRef as MakeCorrectRef } from "./makeCorrection";
import ImportTripLegs from "./importTripLegs";
import ImportBusPass from "./importBusPass";
import ReviewCorrection from "./reviewCorrection";
import ReviewIEHPReplacementClaims from "./reviewIEHPReplacementClaims";
import CreateInvoiceCCAH, { ChildRef as ChildCCAHRef } from "./createInvoiceCCAH";
import CalculateTab, { ChildRef as CalculateRef } from "./CalculateCCAHIncentive";
import { useParams } from "react-router-dom";
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
interface ClientData {
    id: number,
    name: string
}

interface FilterData extends ClientData {
    clientId: number
}

interface StatusData extends FilterData {
    invoiceTypeId: number
    displayOrder?: number
}

interface CheckedProps {
    item: string;
    checked: boolean;
}

type NotificationType = 'success' | 'info' | 'warning' | 'error';
export default function Invoices() {
    const { clientId: routeClientId, invoiceSid } = useParams();
    const childRef = useRef<ChildRef>(null);
    const childCCAHRef = useRef<ChildCCAHRef>(null);
    const makeCorrectRef = useRef<MakeCorrectRef>(null);
    const calculateRef = useRef<CalculateRef>(null);
    const [api, contextHolder] = notification.useNotification();
    const [clientList, setClientList] = useState<FilterData[]>([]);
    const [invoiceTypes, setInvoiceTypes] = useState<FilterData[]>([]);
    const [statusList, setStatusList] = useState<StatusData[]>([]);
    const [invoiceTypesLookup, setInvoiceTypesLookup] = useState<FilterData[]>([]);
    const [statusListLookup, setStatusListLookup] = useState<StatusData[]>([]);
    const [searchByDateRange, setDateRangeSelection] = useState(false);
    const [invoiceNumber, setInvoiceNumber] = useState<string>();
    const [client, setClient] = useState<any | null>(null);
    const [startDate, setStartDate] = useState<string | any>('');
    const [endDate, setEndDate] = useState<string | any>('');
    const [status, setStatus] = useState<any | null>(null);
    const [invoiceType, setInvoiceType] = useState<any | null>(null);
    const [invoiceList, setInvoiceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({});
    const [menuVisible, setMenuVisible] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showModal, setModal] = useState<boolean>(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [modalFooter, setModalFooter] = useState<Element[]>([]);
    const [selectedAction, setSelectedAction] = useState<string>('');
    const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
    const [invoiceData, setInvoiceData] = useState<any>(null);
    const [userAccess, setUserAccess] = useState({
        canGenerate: false,
        canAdd: false
    })
    const [currentTab, setCurrentTab] = useState("invoiceInfoTab");
    const [makeCorrectionInfo, setCorrectionInfo] = useState<any | null>(null);
    const [calculateInfo, setCalculateInfo] = useState<any | null>(null);
    const [changeAtCreate, setChangeAtCreate] = useState<boolean>(false);
    const [resetDone, setResetDone] = useState<boolean>(false);

    const screenWidth = window.innerWidth;
    const drawerScreenWidth = screenWidth * 0.7;
    const percentageWidth = screenWidth * 0.9;
    const defaultWidth = 1000;
    const [drawerConfig, setDrawerConfig] = useState({
        title: 'Invoice',
        width: Math.max(drawerScreenWidth, defaultWidth)
    })
    const [filterLoader, setFilterLoader] = useState(false);
    const [isFiltersReady, setIsFiltersReady] = useState(false);
    const [showTripLegTab, setShowTripLegTab] = useState(true);
    const [showReviewCorrectionsTab, setShowReviewCorrectionsTab] = useState(false);
    const [showIEHPReplacementClaimsTab, setShowIEHPReplacementClaimsTab] = useState(false);
    const lastDeepLinkInvoiceRef = useRef<string | null>(null);
  
    //create Invoice


    const openNotificationWithIcon = (type: NotificationType, message: string, description: string) => {
        api[type]({
            message: message,
            description: description
        });
    };
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });

    const columns: TableColumnsType<any> = [
        {
            title: 'Invoice Date',
            dataIndex: 'invoiceDate',
            render: (text) => dayjs(text).format('MM/DD/YYYY'),
            sorter: true
        },
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            sorter: true
        },
        {
            title: 'Type',
            dataIndex: 'invoiceType',
            sorter: true
        },
        {
            title: 'Status',
            dataIndex: 'invoiceStatus',
            sorter: true
        },
        {
            title: 'DOS Range',
            dataIndex: 'dosRange',
            sorter: true
        },
        {
            title: 'Include Previous Non-billable',
            dataIndex: 'includePreviousNonBillable',
            sorter: true
        },
        {
            title: 'View',
            dataIndex: 'invoiceNumber',
            render: (text, record) => (
                <Button onClick={() => openInvoiceInfoModal(record)} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                    <EyeOutlined />
                </Button>
            )
        },
   ];

    const [isChecked, setChecked] = useState<CheckedProps[]>(
        columns.map((entry: any) => ({ item: entry.title, checked: !entry.hidden }))
    );

    const invoiceColumns = columns.map((item) => ({
        ...item,
        hidden: !isChecked.find(x => x.item === item.title)?.checked,
    }));

    function getFilterData() {
        setFilterLoader(true);
        setIsFiltersReady(false);
        getInvoiceFilters((res: any) => {
            setFilterLoader(false);
            if (res.hasError) {
                setIsFiltersReady(false);
                openNotificationWithIcon("error", "Something went wrong!!!", "");
                return;
            }
            if (res) {
                setClientList(res.clientList);
                setInvoiceTypesLookup(res.invoiceTypeList);
                setStatusListLookup(res.invoiceStatusList);
                setUserAccess({
                    ...userAccess,
                    canGenerate: res.canGenerate,
                    canAdd: res.canAdd
                })
                setIsFiltersReady(true);
            }
        })
    }

    function resetFilters() {
        setInvoiceType(null);
        setStatus(null);
        setClient(null)
        setStartDate('');
        setEndDate('');
        setInvoiceNumber(null);
        if (pageSize == 0) {
            setPageSize(10);
        } else if (currentPage != 1) {
            setCurrentPage(1);
        } else {
            setResetDone(true);
        }
    }

    function getInvoiceList() {
        setLoading(true);
        setInvoiceList([]);
        setModal(false);
        getInvoices({
            "pageIndex": currentPage,
            "pageSize": pageSize,
            "sortField": sortedInfo.order ? sortedInfo.field : null,
            "sortDescending": sortedInfo.order == 'descend',
            "clientId": client ?? null,
            "fromInvoiceDate": startDate && startDate != '' ? startDate : null,
            "toInvoiceDate": endDate && endDate != '' ? endDate : null,
            "invoiceNumber": invoiceNumber?.trim() ?? null,
            "invoiceTypeId": invoiceType ?? null,
            "invoiceStatusId": status
        }, (res: any) => {
            if (res !== 'error') {
                !showTable && setShowTable(true);
                setInvoiceList(res.items);
                setLoading(false)
                setTotalPages(Math.ceil(res.totalRecords / (pageSize / pageSize)));
            } else {
                setInvoiceList([]);
                setLoading(false)
                setTotalPages(1);
            }

        })
    }
    function search() {
        if (!client) {
            openNotificationWithIcon("warning", "Please Select a Client", "");
            return;
        }
        if (pageSize == 0) {
            setPageSize(10);
        } else {
            currentPage == 1 ? getInvoiceList() : setCurrentPage(1);
        }
    }

    const [tableScrollY, setTableScrollY] = useState<number>();

    useEffect(() => {
        getFilterData();
        setPageSize(10);
        document.title = "Invoice";

        const compute = () => {
            const height = window.innerHeight - 520;
            setTableScrollY(height > 0 ? height : undefined);
        };

        compute();
        window.addEventListener("resize", compute);
        return () => window.removeEventListener("resize", compute);
    }, []);

    useEffect(() => {
        if (pageSize != 0)
            getInvoiceList();
    }, [currentPage, pageSize, sortedInfo]);

    useEffect(() => {
        if (resetDone) {
            if (pageSize != 0)
                getInvoiceList();
            setResetDone(false);
        }
    }, [resetDone]);

    useEffect(() => {
        if (!changeAtCreate) {
            if (client && client == invoiceData?.clientId && invoiceType == invoiceData?.invoiceTypeId) {
                search();
                setInvoiceData(null);
            }

            if (client && invoiceType) {
                setStatusList(statusListLookup.filter(x => x.clientId == client && x.invoiceTypeId == invoiceType));
            }
        }
    }, [client, invoiceType])

    useEffect(() => {
        if (!isFiltersReady) {
            return;
        }

        if (!invoiceSid) {
            return;
        }

        const parsedInvoiceSid = Number(invoiceSid);
        if (!Number.isInteger(parsedInvoiceSid) || parsedInvoiceSid <= 0) {
            openNotificationWithIcon("warning", "Invalid invoice id in URL.", "");
            return;
        }

        const parsedClientId = routeClientId ? Number(routeClientId) : null;
        if (routeClientId && (!Number.isInteger(parsedClientId) || (parsedClientId ?? 0) <= 0)) {
            openNotificationWithIcon("warning", "Invalid client id in URL.", "");
            return;
        }

        const deepLinkKey = `${parsedClientId ?? ""}:${parsedInvoiceSid}`;

        // Avoid duplicate fetches for the same deep-link in strict-mode double effects.
        if (lastDeepLinkInvoiceRef.current === deepLinkKey) {
            return;
        }

        lastDeepLinkInvoiceRef.current = deepLinkKey;
        openInvoiceFromUrl(parsedInvoiceSid, parsedClientId);
    }, [routeClientId, invoiceSid, isFiltersReady]);

    useEffect(() => {
        if (invoiceData) {
            if (invoiceData?.clientId) {
                setClient(invoiceData.clientId);
                setInvoiceTypes(invoiceTypesLookup.filter(x => x.clientId == invoiceData.clientId));
                setInvoiceType(invoiceData.invoiceTypeId);
                setModal(false)
            }
        }
    }, [invoiceData])

    const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        setCurrentPage(pagination.current ?? 1);
        setPageSize(pagination.pageSize ?? 10);
        setTotalPages(pagination.total ?? 100);
        setSortedInfo(sorter as SorterResult<any>);
    };

    useEffect(() => {
        if (selectedAction == 'edit') {
            setModal(true);
        }
    }, [selectedAction])

    useEffect(() => {
        if (selectedInvoice) {
            setSelectedAction('edit');
        }
    }, [selectedInvoice])

    function openInvoiceInfoModal(rec?: any) {
        if (rec) {
            setSelectedInvoice(rec);
        } else {
            setSelectedInvoice(null);
            if (client || invoiceType) {
                setInvoiceData({
                    filterType: invoiceType,
                    filterClient: client
                });
            }
            setSelectedAction('add');
            setModal(true);
        }
    }

    function openInvoiceFromUrl(invoiceSId: number, clientIdFromUrl: number | null = null) {
        getInvoice({
            id: invoiceSId,
            clientId: clientIdFromUrl
        }, (res: any) => {
            if (res?.hasError || !res?.info) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : "Invoice not found.";
                openNotificationWithIcon("warning", errorMsg, "");
                return;
            }

            const info = res.info;
            setCurrentTab('invoiceInfoTab');
            setDrawerConfig({
                title: 'Invoice',
                width: Math.max(drawerScreenWidth, defaultWidth)
            });
            openInvoiceInfoModal({
                id: invoiceSId,
                clientId: info?.clientId,
                invoiceTypeId: info?.invoiceTypeId,
                invoiceType: info?.invoiceType,
                invoiceNumber: info?.invoiceNumber
            });
        });
    }

    function clientSelected(e: any) {
        setChangeAtCreate(false);
        setClient(e);
        setInvoiceType(null);
        setInvoiceTypes(invoiceTypesLookup.filter(x => x.clientId == e));
    }

    function handleCallback(data: any) {
        if (data?.canChangeTab) {
            data.makeCorrection && setCorrectionInfo(data.makeCorrection);
            setShowTripLegTab(data.canValidate);
            setShowReviewCorrectionsTab(data.canReviewCorrections);
            setShowIEHPReplacementClaimsTab(data.canReviewReplacementClaims);
        } else if (data?.changeClient && data?.clientId) {
            setChangeAtCreate(true);
            setInvoiceData({
                filterType: null,
                filterClient: data?.clientId
            });
            setClient(data?.clientId);
            setInvoiceType(null);
            setInvoiceTypes(invoiceTypesLookup.filter(x => x.clientId == data?.clientId));
        } else if (data?.changeInvoiceType) {
            setChangeAtCreate(true);
            setInvoiceData({
                ...invoiceData,
                filterType: data?.invoiceType
            });
            setInvoiceType(data?.invoiceType);
        } else if (data?.isInvalid) {
            openNotificationWithIcon("warning", data.errorMessage, "");
        } else if (data.isCancel) {
            closeModal(data);
        } else if (data.showMessage) {
            openNotificationWithIcon("success", data.message, "");
            if (currentTab == 'importTripLegTab' || currentTab == 'importBusPassTab' || currentTab == 'makeCorrectionTab') {
                if (childRef.current) {
                    childRef.current?.getInvoiceData();
                }
            }
        } else if (data.updateDrawerConfig) {
            if (data.width == defaultWidth) {
                setDrawerConfig({
                    ...drawerConfig,
                    width: Math.max(drawerScreenWidth, defaultWidth)
                });
            } else {
                setDrawerConfig({
                    ...drawerConfig,
                    width: Math.max(percentageWidth, data.width)
                });
            }

        } else {
            openNotificationWithIcon("success", data.message, "");

            if (client && client == data.clientId && invoiceType == data.invoiceTypeId) {
                search();
                setInvoiceData(null);
                setSelectedAction('');
            } else {
                setInvoiceData(data);
            }
        }
    }

    function handleCallbackForCCAH(data: any) {
        if (data?.canChangeTab) {
            data.calculate && setCalculateInfo(data.calculate);
        } else if (data?.changeClient && data?.clientId) {
            setChangeAtCreate(true);
            setInvoiceData({
                filterType: null,
                filterClient: data?.clientId
            });
            setClient(data?.clientId);
            setInvoiceType(null);
            setInvoiceTypes(invoiceTypesLookup.filter(x => x.clientId == data?.clientId));
        } else if (data?.changeInvoiceType) {
            setChangeAtCreate(true);
            setInvoiceData({
                ...invoiceData,
                filterType: data?.invoiceType
            });
            setInvoiceType(data?.invoiceType);
        } else if (data?.isInvalid) {
            openNotificationWithIcon("warning", data.errorMessage, "");
        } else if (data.isCancel) {
            closeModal(data);
        } else if (data.showMessage) {
            openNotificationWithIcon("success", data.message, "");
            if (currentTab == 'calculateTab') {
                childCCAHRef.current?.refreshAfterCCAHCalcSave?.();
            }
        } else if (data.updateDrawerConfig) {
            if (data.width == defaultWidth) {
                setDrawerConfig({
                    ...drawerConfig,
                    width: Math.max(drawerScreenWidth, defaultWidth)
                });
            } else {
                setDrawerConfig({
                    ...drawerConfig,
                    width: Math.max(percentageWidth, data.width)
                });
            }

        } else {
            openNotificationWithIcon("success", data.message, "");
            if (invoiceData?.filterClient == data.clientId) {
                search();
                setInvoiceData(null);
                setSelectedAction('');
            } else {
                setInvoiceData(data);
            }
        }
    }

    useEffect(() => {
        if (!showModal) {
            setCorrectionInfo(null);
            setShowIEHPReplacementClaimsTab(false);
            setCurrentTab('invoiceInfoTab');
        }
    }, [showModal])

    function closeModal(data: any) {
        setSelectedInvoice(null);
        if (selectedAction == 'edit') {
            if (client) {
                search();
            } else {
                currentPage == 1 ? getInvoiceList() : setCurrentPage(1);
            }
        }
        setSelectedAction('cancel');
        setSelectedInvoice(null);
        setInvoiceData(null);
        setModal(false);
        setCorrectionInfo(null);
        setShowReviewCorrectionsTab(false);
        setShowIEHPReplacementClaimsTab(false);
        setDrawerConfig({
            title: 'Invoice',
            width: Math.max(drawerScreenWidth, defaultWidth)
        });

    }

    function getInvoicePermissions() {
        getInvoiceActions(selectedInvoice.id, (res) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
            } else {
                if (!res?.canValidate) {
                    setCurrentTab('invoiceInfoTab');
                }
                setShowTripLegTab(res?.canValidate);
                setShowReviewCorrectionsTab(res?.canReviewCorrections);
                setShowIEHPReplacementClaimsTab(res?.canReviewReplacementClaims);
            }
        })
    }

    const handleTabClick = (key: any) => {
        //if (selectedInvoice?.clientId == 10) {
            if (currentTab == "makeCorrectionTab") {
                if (makeCorrectRef.current) {
                    if (makeCorrectRef.current?.bulkDetailsUpdated) {
                        openNotificationWithIcon("warning", "There are unsaved changes, please save them to continue.", "");
                        return;
                    }
                }
            }
            if (key === 'invoiceInfoTab' || (makeCorrectionInfo?.canMakeCorrection && makeCorrectionInfo?.invoiceInfo && key === 'makeCorrectionTab')) {
                setCurrentTab(key);
                if (key == 'invoiceInfoTab') {
                    setDrawerConfig({
                        title: 'Invoice',
                        width: Math.max(drawerScreenWidth, defaultWidth)
                    });
                } else {
                    setDrawerConfig({
                        title: `Invoice - Client: ${clientList.find((x) => x.id == makeCorrectionInfo?.invoiceInfo.clientId)?.name} :: Invoice #: ${makeCorrectionInfo?.invoiceInfo?.invoiceNumber}`,
                        width: Math.max(drawerScreenWidth, defaultWidth)
                    })
                }
            } else if (key == 'importTripLegTab' && selectedInvoice?.invoiceType == "MPSS") {
                setCurrentTab(key);
                setDrawerConfig({
                    title: `Invoice - Client: ${clientList.find((x) => x.id == makeCorrectionInfo?.invoiceInfo.clientId)?.name} :: Invoice #: ${makeCorrectionInfo?.invoiceInfo?.invoiceNumber}`,
                    width: Math.max(drawerScreenWidth, defaultWidth)
                })
            } else if (key == 'importBusPassTab' && selectedInvoice?.invoiceType == "Bus Pass") {
                setCurrentTab(key);
                setDrawerConfig({
                    title: `Invoice - Client: ${clientList.find((x) => x.id == makeCorrectionInfo?.invoiceInfo.clientId)?.name} :: Invoice #: ${makeCorrectionInfo?.invoiceInfo?.invoiceNumber}`,
                    width: Math.max(percentageWidth, defaultWidth)
                })
            } else if (key == 'reviewCorrectionTab') {
                setCurrentTab(key);
                setDrawerConfig({
                    title: `Invoice - Client: ${clientList.find((x) => x.id == makeCorrectionInfo?.invoiceInfo.clientId)?.name} :: Invoice #: ${makeCorrectionInfo?.invoiceInfo?.invoiceNumber}`,
                    width: Math.max(drawerScreenWidth, defaultWidth)
                })
            } else if (key == 'iehpReplacementClaimsTab') {
                setCurrentTab(key);
                setDrawerConfig({
                    title: `Invoice - Client: ${clientList.find((x) => x.id == makeCorrectionInfo?.invoiceInfo.clientId)?.name} :: Invoice #: ${makeCorrectionInfo?.invoiceInfo?.invoiceNumber}`,
                    width: Math.max(drawerScreenWidth, defaultWidth)
                })
            } else if (key == 'calculateTab') {
                setCurrentTab(key);
                setDrawerConfig({
                    title: `Invoice - Client: ${clientList.find((x) => x.id == calculateInfo?.invoiceInfo.clientId)?.name} :: Invoice #: ${calculateInfo?.invoiceInfo?.invoiceNumber}`,
                    width: Math.max(drawerScreenWidth, defaultWidth)
                });
             }
      
    };

    return <ConfigProvider theme={{
        components: {
            Layout: { bodyBg: "#eff1f5", siderBg: "#fff" }
        }
    }} >
        {contextHolder}
        <Layout style={{
            padding: '20px',
            marginBottom: '5px',
            marginTop: '5px',
        }}>
            <Drawer title={drawerConfig.title} destroyOnClose={true} maskClosable={false} onClose={closeModal} open={showModal} width={drawerConfig.width} styles={{ body: { background: '#eff1f5' } }}>
                <div>
                    {
                        selectedAction == 'edit' &&
                        <Tabs type="card" style={{ width: '100%', background: '#fff' }} tabBarStyle={{ marginBottom: '0px' }} activeKey={currentTab} onChange={handleTabClick}>
                            <TabPane tab="Invoice Information" key="invoiceInfoTab">
                                    {selectedInvoice?.invoiceType == "Incentive" ? (
                                    <CreateInvoiceCCAH key={`invoice-info-${selectedInvoice?.id ?? "new"}`} ref={childCCAHRef} clientList={clientList} invoiceTypeLookup={invoiceTypesLookup} selectedInvoice={selectedInvoice} action={selectedAction} filterData={invoiceData} modal={showModal} userAccess={userAccess} statusList={statusListLookup} parentCallback={handleCallbackForCCAH} />
                                ) : (
                                    <CreateInvoice key={`invoice-info-${selectedInvoice?.id ?? "new"}`} ref={childRef} clientList={clientList} invoiceTypeLookup={invoiceTypesLookup} selectedInvoice={selectedInvoice} action={selectedAction} filterData={invoiceData} modal={showModal} userAccess={userAccess} statusList={statusListLookup} parentCallback={handleCallback} />
                                )}
                            </TabPane>
                            {
                                selectedInvoice && selectedInvoice?.invoiceType == "MPSS" && showTripLegTab &&
                                (
                                    <TabPane tab="Import Trip Legs" key="importTripLegTab">
                                        {
                                            currentTab == 'importTripLegTab' && makeCorrectionInfo?.invoiceInfo &&
                                            <ImportTripLegs clientList={clientList} invoiceInfo={makeCorrectionInfo?.invoiceInfo} parentCallback={handleCallback} />
                                        }
                                    </TabPane>
                                )
                            }
                            {
                                selectedInvoice && selectedInvoice?.invoiceType == "Bus Pass" && showTripLegTab &&
                                (
                                    <TabPane tab="Import Records" key="importBusPassTab">
                                        {
                                            currentTab == 'importBusPassTab' && makeCorrectionInfo?.invoiceInfo &&
                                            <ImportBusPass invoiceInfo={makeCorrectionInfo?.invoiceInfo} parentCallback={handleCallback} />
                                        }
                                    </TabPane>
                                )
                            }
                                {
                                    selectedInvoice?.invoiceType != "Incentive" && makeCorrectionInfo?.canMakeCorrection &&
                                (
                                <TabPane tab="Make Correction" key="makeCorrectionTab" disabled={!makeCorrectionInfo?.canMakeCorrection}>
                                    {
                                        currentTab == 'makeCorrectionTab' && makeCorrectionInfo?.invoiceInfo &&
                                        <MakeCorrection ref={makeCorrectRef} clientList={clientList} invoiceInfo={makeCorrectionInfo?.invoiceInfo} parentCallback={handleCallback} />
                                    }
                                        </TabPane>
                                    )
                                
                              }
                            {
                                showReviewCorrectionsTab &&
                                (
                                    <TabPane tab="Review Corrections" key="reviewCorrectionTab" >
                                        {
                                            currentTab == 'reviewCorrectionTab' && makeCorrectionInfo?.invoiceInfo &&
                                            <ReviewCorrection invoiceInfo={makeCorrectionInfo?.invoiceInfo} parentCallback={handleCallback} />
                                        }
                                    </TabPane>
                                )
                            }
                            {
                                showIEHPReplacementClaimsTab &&
                                (
                                    <TabPane tab="Replacement Claims to Submit" key="iehpReplacementClaimsTab" >
                                        {
                                                currentTab == 'iehpReplacementClaimsTab' && makeCorrectionInfo?.invoiceInfo &&
                                            <ReviewIEHPReplacementClaims invoiceInfo={makeCorrectionInfo?.invoiceInfo} parentCallback={handleCallback} />
                                        }
                                    </TabPane>
                                )
                            }
                                { selectedInvoice?.invoiceType == "Incentive" &&
                                <TabPane tab="Calculate Incentive" key="calculateTab" disabled={!calculateInfo?.canCalculate}>
                                    {
                                        currentTab == 'calculateTab' && calculateInfo?.invoiceInfo &&
                                        <CalculateTab ref={calculateRef} invoiceInfo={calculateInfo?.invoiceInfo} parentCallback={handleCallbackForCCAH} />
                                    }
                                </TabPane>
                            }
                        </Tabs>
                    }
                    {
                        selectedAction != 'edit' && (client == 5 ? (
                            <CreateInvoiceCCAH ref={childCCAHRef} clientList={clientList} invoiceTypeLookup={invoiceTypesLookup} selectedInvoice={selectedInvoice} action={selectedAction} filterData={invoiceData} modal={showModal} userAccess={userAccess} statusList={statusListLookup} parentCallback={handleCallbackForCCAH} />
                        ) : (
                            <CreateInvoice ref={childRef} clientList={clientList} invoiceTypeLookup={invoiceTypesLookup} selectedInvoice={selectedInvoice} action={selectedAction} filterData={invoiceData} modal={showModal} userAccess={userAccess} statusList={statusListLookup} parentCallback={handleCallback} />
                        ))
                    }
                </div>
            </Drawer>
            <h3 style={{ textTransform: 'uppercase', marginTop: '0px' }}>Invoices</h3>
            <Flex justify='space-between' style={{ padding: "1rem", alignItems: "center", background: '#fff' }}>
                <label><SearchOutlined />&nbsp;Search</label>
                {userAccess.canAdd && <Button onClick={() => openInvoiceInfoModal()} style={{ marginLeft: '5px' }} type="primary" icon={<PlusOutlined />}>
                    Add Invoice
                </Button>
                }
            </Flex>
            <Skeleton loading={filterLoader} active>
                <Row type="flex" style={{ padding: '1rem', paddingTop: "0px", background: '#fff' }}>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Client"
                            onChange={(e) => clientSelected(e)}
                            value={client}
                        >
                            {clientList && clientList.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Type"
                            onChange={(e) => {
                                setInvoiceType(e);
                                setChangeAtCreate(false);
                            }}
                            value={invoiceType}
                            disabled={!client}
                            allowClear
                        >
                            {invoiceTypes && invoiceTypes.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={12}>
                        <RangePicker
                            placeholder={["From Invoice Date", "To Invoice Date"]}
                            style={{ width: '100%' }}
                            format="MM/DD/YYYY"
                            value={[startDate, endDate]}
                            onChange={(dates: any) => {
                                if (dates) {
                                    setStartDate(dates[0]);
                                    setEndDate(dates[1]);
                                } else {
                                    setStartDate('');
                                    setEndDate('');
                                }
                            }}
                        />
                    </Col>
                </Row>
            <Row type="flex" style={{ padding: '1rem', paddingTop:"0px", background: '#fff' }}>
                    <Col span={6}>
                        <Input value={invoiceNumber} placeholder="Invoice Number" style={{ width: '90%' }} allowClear onChange={(e) => setInvoiceNumber(e?.target?.value)} />
                    </Col>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Status"
                            onChange={(e) => setStatus(e)}
                            value={status}
                            disabled={!client || !invoiceType}
                            allowClear
                        >
                            {statusList && statusList.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
                <Flex justify='end' style={{ marginBottom: "2rem", padding: "1rem", paddingTop: "0px", background: '#fff' }} gap='small'>
                    <Button onClick={search} loading={loading} style={{ marginLeft: '5px' }} type="primary">
                        Search
                    </Button>
                    <Button onClick={resetFilters} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', marginLeft: '5px', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                        Reset
                    </Button>
                </Flex>
            </Skeleton>
            <ColumnDropdown columns={columns} menuVisible={menuVisible} position={position} isChecked={isChecked} setChecked={setChecked} />
            {showTable && <Table style={{ background: "#fff" }}
                scroll={{
                    y: invoiceList?.length > 0 ? tableScrollY : undefined
                }}
                dataSource={invoiceList}
                pagination={{
                    defaultCurrent: 1,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalPages,
                    showTotal: (total, range) => `${range[0] || 0}-${range[1] || 1} of ${total} items`,
                    showSizeChanger: true,
                }}
                columns={invoiceColumns}
                onChange={handleTableChange}
                size="small"
                rowKey="invoiceNumber"
                loading={{ indicator: <LoaderSpinner size={24} topMargin="10px" />, spinning: loading }}
                onHeaderRow={(columns, index) => {
                    return {
                        onContextMenu: (event) => {
                            event.preventDefault();
                            if (!menuVisible) {
                                document.addEventListener(`click`, function onClickOutside() {
                                    setMenuVisible(false);
                                    document.removeEventListener(`click`, onClickOutside);
                                });
                            }
                            setMenuVisible(true);
                            setPosition({ x: event.clientX, y: event.clientY });
                        }
                    };
                }}
            />}
        </Layout>
    </ConfigProvider>
}